import axios from 'axios';
import { ErrorHandler } from './apiService';

export class HttpClient {
  constructor(baseURL, headers = {}) {
    this.client = axios.create({
      baseURL,
      headers
    });

    this.setupInterceptors();
  }

  setupInterceptors() {
    this.client.interceptors.response.use(
      response => response,
      error => ErrorHandler.handleAuthError(error)
    );
  }

  async get(url, params = {}) {
    const response = await this.client.get(url, { params });
    return response.data;
  }

  async put(url, data, params = {}) {
    const response = await this.client.put(url, data, { params });
    return response.data;
  }

  async post(url, data, params = {}) {
    const response = await this.client.post(url, data, { params });

    return response.data;
  }
}